// Dynamically require all SCSS files in the current directory and subdirectories
// const requireAll = (requireContext) => requireContext.keys().forEach(requireContext);
// const styles = require.context('.', true, /\.scss$/);

// requireAll(styles);
import './styles.scss';
import './admin.scss';
import './admin/directory_manager.scss';
// import './admin/railspress.scss';
import './railspress.scss';
